import React from 'react';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';
import Hero from '../../components/Service/CoursesIndex/Hero';
import AboutCourses from '../../components/Service/CoursesIndex/About';
import CourseList from '../../components/Service/CoursesIndex/CourseList';
import StartNow from '../../components/organisms/StartNow';

const CoursesIndex = () => {
  const { t } = useTranslation('common');
  return (
    <div>
      <Head>
        <title>{t('title.courses.index')}</title>
        <meta name="description" content={t('description.courses.index')} />
      </Head>
      <div className="breadCrumb" />
      <Hero />
      <AboutCourses />
      <CourseList />
      <StartNow />
    </div>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
});

export default CoursesIndex;
